module.exports = __webpack_public_path__ + "8003069bc3fc25a2fad2c67c70606f00.svg";